import { OutlinedButton } from "@/components/ui/buttons";
import { useLogout } from "@/hooks/use-logout";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface LogoutButtonProps {
  onLogoutComplete?: () => void;
  className?: string;
}

export const LogoutButton = memo(function LogoutButton({
  onLogoutComplete,
  className,
}: LogoutButtonProps) {
  const { logout } = useLogout();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      onLogoutComplete?.();
    }
  };

  return (
    <OutlinedButton
      color="gray"
      textCase="normal"
      onClick={handleLogout}
      className={cn(
        textVariants.bodySingleLine,
        "text-text-input-error-default rounded-[14px]",
        className,
      )}
    >
      Log Out
    </OutlinedButton>
  );
});
